import React, { useEffect, useRef, useState } from 'react';
import EventEmitter from 'reactjs-eventemitter';

function V2Text({ current, sendResponse }) {
  const [msg, setMsg] = useState('');
  const sent = useRef(false);
  const mounted = useRef(true);
  useEffect(() => () => (mounted.current = false), []);

  const send = (e) => {
    e.preventDefault();
    if (sent.current) return;
    sent.current = true;
    // v1 sends a single space for an empty answer; keep the same contract with the backend.
    const answer = msg.trim() || ' ';
    sendResponse(answer, answer, current);
    EventEmitter.dispatch('stopVideos');
    // Unlock if the store's double-submit guard swallowed the answer and the field is still here.
    setTimeout(() => mounted.current && (sent.current = false), 2500);
  };

  return (
    <form className="v2-text" onSubmit={send}>
      <input
        autoFocus
        autoComplete="off"
        className="v2-text__input"
        placeholder={current.placeholder || 'Skriv ditt svar…'}
        value={msg}
        onChange={(e) => setMsg(e.target.value)}
      />
      <button type="submit" className="v2-text__send" aria-label="Skicka">
        <svg viewBox="0 0 20 20" aria-hidden="true">
          <path d="M4 10h11M11 5l5 5-5 5" />
        </svg>
      </button>
    </form>
  );
}

export default V2Text;
